import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyBnpMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="bnpGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#00A651", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#008C3A", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#004D28", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#bnpGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 18 }).map((_, j) => {
            const x = -315 + i * 45;
            const y = -405 + j * 45;
            return (
              <rect
                key={`currency-${i}-${j}`}
                x={x - 18}
                y={y - 18}
                width={36}
                height={36}
                fill="none"
                stroke="#FFFFFF"
                strokeWidth={1.5}
                opacity={0.15}
                rx={4}
              />
            );
          })
        )}
        {Array.from({ length: 16 }).map((_, r) => (
          <circle
            key={`liquidity-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 25}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 4 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.014}
          />
        ))}
        <rect x={-50} y={-50} width={100} height={100} fill="none" stroke="#00A651" strokeWidth={3} opacity={0.6} rx={6} />
        <circle cx={0} cy={0} r={35} fill="#008C3A" opacity={0.4} />
      </g>
    </svg>
  );
}
